import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authenticateUserLogin } from "../../services/auth/authorisation";
import LoginForm from "./components/LoginForm";
import LoginTitle from "./components/LoginTitle";
import { AUTH_ALERTS, AUTH_MESSAGES } from "./constants/authConstants";

/**
 * The Login component handles user authentication and provides a form for users to input their credentials.
 * @param {Function} checkAuthUser - A function that checks the authenticated user's permissions after login.
 */
function Login({ checkAuthUser }) {
  const navigate = useNavigate();
  const location = useLocation();
  const redirectPath = location.state?.from || "/dashboard";
  const [formData, setFormData] = useState({
    userId: "",
    password: "",
    otp: "",
  });

  /** Handles the login process by calling the authenticateUserLogin function and checking the response. */
  const handleLogin = async () => {
    const authenticated = await authenticateUserLogin(formData.userId, formData.password, formData.otp);

    switch (authenticated.msg) {
      case AUTH_MESSAGES.SUCCESS:
        await checkAuthUser();
        navigate(redirectPath, { replace: true });
        break;

      case AUTH_MESSAGES.CHANGE_PASSWORD:
        await checkAuthUser();
        navigate("/Settings");
        alert(AUTH_ALERTS.PASSWORD_EXPIRED);
        break;

      default:
        alert(`${AUTH_ALERTS.ACCESS_DENIED}\n\nReason: ${authenticated.msg}`);
    }
  };

  // Handler functions
  const handleUserIdChange = (value) => setFormData((prev) => ({ ...prev, userId: value }));
  const handlePasswordChange = (value) => setFormData((prev) => ({ ...prev, password: value }));
  const handleOtpChange = (value) => setFormData((prev) => ({ ...prev, otp: value }));

  return (
    <Box display="flex" alignItems="center" justifyContent="center" minHeight="100vh">
      <Paper elevation={10} sx={{ borderRadius: "20px", width: { xs: "100%", sm: "auto", md: "60%" } }}>
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          sx={{ py: { xs: "0vh", sm: "15vh" }, minHeight: { xs: "100vh", sm: "50vh" } }}
        >
          <LoginTitle />

          <Grid size={8} pb={6}>
            <LoginForm
              userId={formData.userId}
              password={formData.password}
              otp={formData.otp}
              setUserId={handleUserIdChange}
              setPassword={handlePasswordChange}
              setOtp={handleOtpChange}
              handleLogin={handleLogin}
            />
          </Grid>
          <Button variant="outlined" size="large" sx={{ mt: 3 }} onClick={handleLogin}>
            Login
          </Button>
        </Grid>
      </Paper>
    </Box>
  );
}

export default Login;
